import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import { useState } from 'react'

import styles from './PaymentMethodStatusDialog.module.scss'
import { ENABLE_PAYMENT_METHOD_NOTE, isDisableNoteValid } from './utils'

const PaymentMethodStatusDialog = ({
  error,
  isDisabling,
  isSaving,
  onClose,
  onConfirm
}) => {
  const [note, setNote] = useState('')

  const handleConfirm = () =>
    onConfirm(isDisabling ? note.trim() : ENABLE_PAYMENT_METHOD_NOTE)

  return (
    <ConfirmationDialog
      title={`${isDisabling ? 'Disable' : 'Enable'} payment method`}
      theme="blacklist"
      positiveMessage={isSaving ? 'Updating...' : 'Confirm'}
      negativeMessage="Cancel"
      onClose={isSaving ? null : onClose}
      onReject={isSaving ? null : onClose}
      onConfirm={handleConfirm}
      isButtonDisabled={isSaving || (isDisabling && !isDisableNoteValid(note))}
      isRejectButtonDisabled={isSaving}
      hasCloseButton={!isSaving}
      maxWidth={520}
    >
      {isDisabling ? (
        <label className={styles.noteField}>
          <span>Disable reason</span>
          <textarea
            value={note}
            onChange={event => setNote(event.target.value)}
            placeholder="Enter a reason for disabling this payment method"
            rows={4}
            maxLength={500}
            autoFocus
          />
        </label>
      ) : (
        <p className={styles.verificationText}>{ENABLE_PAYMENT_METHOD_NOTE}</p>
      )}
      {error && <p className={styles.error}>{error}</p>}
    </ConfirmationDialog>
  )
}

export default PaymentMethodStatusDialog
